<!--
================================================
Un composant servant à afficher un bouton c2a pour inviter à mettre à niveau l'abonnement (affiché dans AppNavbarComp).

Url d'accès :
http://localhost:8080/fr/sega-inc/sega-workspace/subscription?cycle=month&pgr=fr-3ertuixp
================================================
-->

<!------------------------------------------------
+++++++++++++++++++++ HTML +++++++++++++++++++++++
-------------------------------------------------->

<template>
    <span id="PremiumUpgradeC2aBtnComp" class="" v-bind:class="{'darkMode':themeToDisplay=='dark'}">

      <router-link v-if="
      activeSubscription !=null
      && activeSubscription.status != 'active'
      && $auth.hasRole('ROLE_ADMIN')
      " class="button is-outlined is-size-7 mt-4  upgradeC2aBtn"
                   v-bind:to="{ name: 'workspace-subscription',params:{locale:locale,organization:organizationSlug, workspace:$auth.getActiveWorkspace()},query:{cycle:'month',pgr:planGroup4Locale}}">
        <span>{{ $t('MettreÀNiveau') }}</span>
        <font-awesome-icon class="icon ml-1 is-size-7" :icon="['fas', 'medal']"/>
      </router-link>

    </span>
</template>

<!------------------------------------------------
+++++++++++++++++++ JAVASCRIPT++++++++++++++++++++
-------------------------------------------------->


<script>
import {mapState} from 'vuex'
import SentryMixin from "@/mixins/SentryMixin.js";
import GlobalErrorNotification from "@/mixins/GlobalErrorNotificationMixin.js";
import InterceptorMixin from "@/mixins/InterceptorMixin.js";
import TrackingMixin from "@/mixins/TrackingMixin";
import i18nMixin from "@/mixins/i18nMixin";

export default {
  name: 'PremiumUpgradeC2aBtnComp', //utile dans vue dev tool
  mixins: [
    GlobalErrorNotification,
    SentryMixin,
    InterceptorMixin,
    TrackingMixin,
    i18nMixin
  ],
  // components: {},

  data: function () {
    return {
      locale: this.$route.params.locale,
      // pour les composants où l'user est identifié ///////////////////////
      organizationSlug: this.$route.params.organization,
      activeWorkspace: this.$auth.getActiveWorkspace(), //@todo dynamiser dans #290 https://gitlab.com/ousmane1/kronocloud/-/issues/290

      componentIsReady: false, // indique quand le composant est prêt à être affiché
      activeSubscription: null, // la subscription actuelle du Workspace
      // =================================================================
    }
  },

  computed: {
    // computed props for store :
    ...mapState({
      user: state => state.user,
      themeToDisplay: state => state.app.themeToDisplay
    }),

  },


  methods: {

    /*
    Effectue une requête pour récupérer :
     - la stripe subscription en cours dans le workspace

       @note : Cette Méthode a été copiée de WorkspaceSubscriptionView, c'est pourquoi le backend retourne en plus des infos non utiles ici :
         - le produtct lié à la subscription stripe
         - l'email de l'utilisateur atuel
         - le nombre total d'utilisateurs actif dans le workspace (récupéré en même temps par souci d'optimisation)
    */
    getWorkspaceSubscription() {
      let self = this;
      return self.$http
          .get(`/s/organizations/${self.organizationSlug}/workspaces/${self.activeWorkspace}/subscription/current`
              , {
                headers: {Authorization: self.$auth.header()},

              })
          .then(function (response) {
            self.$store.commit('UpdateGlobalNotificationCompVisibility', false) // masquage d'une éventuelle erreur

            self.$store.commit('UpdateSubscriptionViewWorkspaceTrialEnd', response.data.subscription.trial_end) //@todo faut-il garder cette ligne ici (copiée depuis WorkspaceSubscriptionView mais pas directement utilisée ici)

            self.activeSubscription = response.data.subscription

            self.componentIsReady = true;
            return {}
          })
          .catch(function (error) {
            let errorCode = '0055b'
            let errorMsg = 'error on fetching stripe subscription'
            self.showGlobalErrorNotif(self, errorCode)
            self.$gtag.exception({'description': 'error ' + errorCode + ' | ' + errorMsg, 'fatal': false})

            self.$mixpanel.track('global error displayed', {"id": errorCode, "detail": errorMsg})
            self.$sentry.captureMessage(`Error ${errorCode} > ${errorMsg} : ${error}`, 'error')

          }).then(() => {
            // toujours exécuté
            self.componentIsReady = true;
          })
    },
  },

  // LIFECYCLE HOOKS (https://v2.vuejs.org/v2/guide/instance.html#Lifecycle-Diagram)
  mounted: function () {

    this.getWorkspaceSubscription()

  },
  beforeDestroy() {
  },
}
</script>

<!------------------------------------------------
++++++++++++++++++++++ CSS +++++++++++++++++++++++
-------------------------------------------------->

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../assets/css/globalVar.scss";
@import "../assets/css/bulmaCustom.scss";

#PremiumUpgradeC2aBtnComp {

  //////////////////////////////////////////
  // LIGHT THEME ///////////////////////////
  .upgradeC2aBtn {
    color: $brandThird !important;

    .icon {
      color: $brandPremium !important;
    }

    transition: box-shadow 300ms;

    &:hover {
      box-shadow: 0 0 2px #ccc;
    }

    &:active {
      border-color: $brandPremium !important;
    }
  }

  /////////////////////////////////////////
  // DARK THEME ///////////////////////////
  &.darkMode {
    .upgradeC2aBtn {
      background-color: $darkBg !important;
      border-color: $darkLightBlue !important;

      &:hover {
        background-color: darken($darkBg, 4%) !important;
      }

      transition: background-color 300ms ease-out;
      box-shadow: none !important;

      span {
        color: $darkContrastTxt !important;
      }
    }
  }

}
</style>
